import { useTranslation } from 'react-i18next';
import { whyButlerWorks } from '@/mocks/corporateClinicData';

function renderParagraphs(text: string, className: string) {
  return text
    .split(/(?:\r?\n){2,}/)
    .filter((part) => part.length > 0)
    .map((part, index) => (
      <p key={index} className={className}>
        {part}
      </p>
    ));
}

export default function WhyButlerWorks() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[900px] mx-auto px-8">
        <div className="text-center mb-14">
          {renderParagraphs(
            String(t('corporateClinic.why.label')),
            'text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label',
          )}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('corporateClinic.why.title')}
          </h2>
          {renderParagraphs(
            String(t('corporateClinic.why.titleEn')),
            'section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4',
          )}
          <div className="gold-line mx-auto mb-5"></div>
          {renderParagraphs(
            String(t('corporateClinic.why.lead1')),
            'text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto',
          )}
          {renderParagraphs(
            String(t('corporateClinic.why.lead2')),
            'text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto mt-3',
          )}
        </div>

        <div className="space-y-6">
          {whyButlerWorks.map((item, idx) => (
            <div
              key={idx}
              className="flex flex-col md:flex-row items-start gap-5 p-6 bg-background-50 border border-background-200/60"
            >
              <div className="w-11 h-11 rounded-full bg-accent-500/8 border border-accent-500/20 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-accent-500 text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em] mb-3">
                  {t(`corporateClinic.why.${idx}.title`)}
                </h3>
                {renderParagraphs(
                  String(t(`corporateClinic.why.${idx}.desc`)),
                  'text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed',
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
